import * as React from 'react';
import * as classnames from 'classnames';
import MediaManager from '../../../../../../libraries/mediaLibrary/MediaManager';
import { UilPen, UilImagePlus } from '@iconscout/react-unicons';
interface UploadImageProps {
    label?: string;
    subLabel?: string;
    hasMultipleImages?: boolean;
    mediaURL?: string;
    mediaURLs?: string[];
    disabled?: boolean;
    error?: any;
    position?: 'center' | 'left';
    appyCurrentImage: (data: {
        mediaURL: string;
        label?: string;
        type?: string;
    }) => void;
}

const UploadImage: React.FC<UploadImageProps> = ({
    label,
    subLabel,
    hasMultipleImages,
    mediaURL,
    error,
    disabled,
    position,
    appyCurrentImage
}: UploadImageProps) => {
    const [showMediaManager, setShowMediaManager] = React.useState(false);
    return (
        <div className="row">
            <div className="col-md-12 form-group-header">
                {label || 'Upload Image'}
                <span>{subLabel}</span>
            </div>
            {error?.mediaURL ? (
                <div className="col-md-12 form-group__error-msg">
                    please add an image
                </div>
            ) : null}
            <div className="col-md-12 form-group">
                <div
                    className={classnames('media--container', {
                        centered: position === 'center'
                    })}
                >
                    <div
                        className={classnames('media--contents', {
                            '--multi': hasMultipleImages
                        })}
                    >
                        <MediaManager
                            showMediaManager={showMediaManager}
                            toggleMediaManager={setShowMediaManager}
                            showMediaLibrary
                            applyCurrentMedia={appyCurrentImage}
                            type="image"
                        >
                            <span
                                className={classnames(
                                    'form-group__icon form-group__icon--large',
                                    {
                                        uploaded: !!mediaURL,
                                        error: error?.mediaURL
                                    }
                                )}
                                onClick={() => setShowMediaManager(true)}
                            >
                                {mediaURL ? (
                                    <>
                                        <img src={mediaURL} />
                                        <div
                                            className="hover-container"
                                            onClick={() =>
                                                setShowMediaManager(true)
                                            }
                                        >
                                            <div className="hover-container--item">
                                                <UilPen size={16} />
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <UilImagePlus size={40} />
                                )}
                            </span>
                        </MediaManager>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadImage;
